import styled from 'styled-components';
export var ImageLogo = styled('img').withConfig({
  displayName: "styles__ImageLogo",
  componentId: "sc-dujzsw-0"
})(["height:35px;@media (min-width:768px){height:48px;}"]);
export var Container = styled('div').withConfig({
  displayName: "styles__Container",
  componentId: "sc-dujzsw-1"
})(["display:flex;flex-direction:column;flex-wrap:wrap;gap:20px;@media (min-width:768px){height:400px;gap:40px;}"]);
export var LinkItem = styled('a').withConfig({
  displayName: "styles__LinkItem",
  componentId: "sc-dujzsw-2"
})(["display:flex;flex-direction:row;justify-content:space-between;align-items:center;padding:16px;background:#ffffff;border:1px solid #f3f4f4;box-shadow:0px 2px 8px rgba(0,0,0,0.05);border-radius:16px;font-family:var(--font-family-system);width:100%;color:#000;@media (min-width:768px){width:calc(50% - 20px);}"]);
export var ImageLogoContainer = styled('div').withConfig({
  displayName: "styles__ImageLogoContainer",
  componentId: "sc-dujzsw-3"
})(["position:relative;"]);
export var CheckmarkContainer = styled('div').withConfig({
  displayName: "styles__CheckmarkContainer",
  componentId: "sc-dujzsw-4"
})(["position:absolute;top:-5px;right:-5px;background-color:#1ab11d;color:#fff;display:flex;align-items:center;justify-content:center;border-radius:50%;padding:2px;"]);